// Public screens carry no appearance toggle, so the server renders whichever mode the visitor
// picked while signed in. Only `system` is left to resolve, because it depends on the OS.
const prefersDark = window.matchMedia("(prefers-color-scheme: dark)");

const applySystemMode = () => {
  document.documentElement.dataset.mode = prefersDark.matches ? "dark" : "light";
};

if (document.documentElement.dataset.mode === "system") {
  applySystemMode();
  prefersDark.addEventListener("change", applySystemMode);
}
